import { r as s, h as t, c as r } from "./index-f8317a8e.js";
import { s as a } from "./index-6d9eeb53-c70fc8a7.js";
import "./index-53420959-9b1699ec.js";
import "react";
import "react-dom";
const l = ".sc-add-circle-icon-h{display:flex}", i = l, n = class {
  constructor(e) {
    s(this, e), this.width = "24", this.height = "25";
  }
  render() {
    return t("svg", { key: "c79d0b353d7f86b3aa85263b6826eff7f859d4fc", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "db54a7ebb7020a9c38678dbe369ae07256cf3ad5", d: "M12 2.5c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10ZM12 4a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm0 3.5a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 12 7.5Z", fill: "currentColor" }));
  }
};
n.style = i;
const o = ':host{display:block;height:auto;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;width:100%}label{display:flex;color:var(--nylas-base-800, #293056);font-size:14px;font-style:normal;font-weight:400;line-height:150%;flex-direction:column;gap:4px;font-family:var(--nylas-font-family);font-size:16px;color:var(--nylas-base-800)}label.error{color:var(--nylas-error)}label span.required{color:var(--nylas-error);padding:0 0.25rem}label p{margin:0}label .error{color:var(--nylas-error)}.input_wrapper{display:flex;align-items:center;gap:1rem}input[type=text],input[type=email]{display:flex;height:48px;padding-left:16px;align-items:center;gap:8px;align-self:stretch;border-radius:var(--nylas-border-radius-2x);border:1px solid var(--nylas-base-300);background:var(--nylas-base-0);width:-webkit-fill-available;color:var(--nylas-base-900);font-size:16px;font-style:normal;font-weight:400;line-height:150%;width:-moz-available;width:-webkit-fill-available}input[type=text]:focus,input[type=email]:focus{outline-color:var(--nylas-primary)}input[type=text].error,input[type=email].error{border-radius:var(--nylas-border-radius-2x);font-weight:600;border-color:var(--nylas-error);border-width:2px}input[type=text].error::placeholder,input[type=email].error::placeholder{font-weight:400}input[type=text]::placeholder,input[type=email]::placeholder{color:var(--nylas-base-300)}', h = o, d = {
  email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  phone_number: /^[0-9]{10}$/
}, p = {
  email: "name@example.com",
  phone_number: "1234567890"
}, u = class {
  constructor(e) {
    s(this, e), this.nylasFormInputChanged = r(this, "nylasFormInputChanged", 7), this.nylasFormInputBlurred = r(this, "nylasFormInputBlurred", 7), this.name = "input", this.defaultValue = "", this.label = "", this.type = "text", this.placeholder = p[this.type], this.required = !1, this.readOnly = !1, this.autoFocus = !1, this.pattern = void 0, this.maxLength = 255, this.patternError = "", this.requiredError = "", this.value = "", this.error = "";
  }
  handleDefaultValueChange(e) {
    this.value = a(e), this.value && this.validatePattern(this.value);
  }
  componentWillLoad() {
    this.value = a(this.defaultValue), this.type !== "text" && !this.pattern && (this.pattern = d[this.type]), this.value && this.validatePattern(this.value);
  }
  handleBookingFormSubmitted(e) {
    this.validatePattern(this.value), this.error && e.preventDefault();
  }
  handleInput(e) {
    this.error = "", this.value = a(e.target.value), this.nylasFormInputChanged.emit({
      value: this.value,
      name: this.name,
      label: this.label,
      error: this.error,
      type: this.type
    });
  }
  handleBlur() {
    this.nylasFormInputBlurred.emit({
      value: this.value,
      name: this.name
    });
  }
  validatePattern(e) {
    if (this.error = "", this.required && !e) {
      this.error = this.requiredError || "This field is required.";
      return;
    }
    !this.pattern || !e && !this.required || (this.pattern.test(e) ? this.error = "" : this.error = this.patternError || "Invalid format.");
  }
  render() {
    return t("label", { key: "643d9c63e361e7bf111607ff56f2b9c1624bc997", part: "ic__label", class: { error: !!this.error } }, this.label && t("p", null, t("span", { class: "label" }, this.label), this.required && t("span", { class: "required" }, "*")), t("div", { key: "1819029075da8baa63cb1cfefede1c2058afd5b1", part: "ic__input_wrapper", class: "input_wrapper" }, t("input", { key: "62f6935e105cd1f7eeb767de7fcb10ece8c71896", type: "text", name: this.name, part: "ic__input", readOnly: this.readOnly, autoFocus: this.autoFocus, value: this.value, maxLength: this.maxLength, placeholder: this.placeholder, class: { error: !!this.error }, onInput: (e) => this.handleInput(e), onBlur: () => this.handleBlur() }), t("slot", { key: "fddbb71ab41c0de12b4046aedfe5aee2ceece8f7", name: "additional-input" })), this.error && t("span", { class: "error help-text" }, this.error));
  }
  static get watchers() {
    return {
      defaultValue: ["handleDefaultValueChange"]
    };
  }
};
u.style = h;
export {
  n as add_circle_icon,
  u as input_component
};
